import * as React from "react";
import { LocalizedLink } from "gatsby-theme-i18n";

const Link = ({ children, href, isActive, ...props }) => {
  if (!href) {
    return <a {...props}>{children}</a>;
  } else if (href.startsWith("/")) {
    return (
      <LocalizedLink to={href} {...props}>
        {children}
      </LocalizedLink>
    );
  } else {
    return (
      <a href={href} {...props}>
        {children}
      </a>
    );
  }
};

export default Link;
